import React from "react";
import {
  getFontFamily,
  getFontSize,
  getTextColor,
} from "../../../service/ui/UI";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

type Props = {
  fontName?: string;
  fontSize?: string;
  textColor?: string;
  className?: string;
  center?: boolean;
  children?: React.ReactNode;
  maxLine?: number;
};

//  React.ReactElement or JSX.Element - // expects a single element
//  React.ReactNode; // allows multiple children

const fontNameClass = (
  fontName: string,
  fontSize: string = "",
  center: boolean = false,
  textColor: string = "",
  maxLine: number = 0
): string => {
  let classes: Array<string> = [];
  const fontNameClass = getFontFamily(
    UtilityHelper.isNotEmpty(fontName) ? fontName : "Book"
  );
  const fontSizeClass = getFontSize(fontSize);
  const textColorClass = getTextColor(
    UtilityHelper.isNotEmpty(textColor) ? textColor : "theme-label"
  );

  if (UtilityHelper.isNotEmpty(fontNameClass)) {
    classes.push(fontNameClass);
  }
  if (UtilityHelper.isNotEmpty(fontSizeClass)) {
    classes.push(fontSizeClass);
  }
  if (UtilityHelper.isNotEmpty(textColorClass)) {
    classes.push(textColorClass);
  }
  if (center) {
    classes.push("text-center");
  }
  if (maxLine > 0) {
    classes.push(`ellipsis ${maxLine > 0 ? `line-${maxLine}` : ""}`);
  }

  return classes.join(" ");
};

export const TextBlock: React.FC<Props> = ({
  children,
  fontName = "",
  fontSize = "",
  className = "",
  center = false,
  textColor = "theme-label",
  maxLine = 0,
}) => {
  const classes: string = fontNameClass(
    fontName,
    fontSize,
    center,
    textColor,
    maxLine
  );
  return <div className={`${classes} ${className}`}>{children}</div>;
};

export const TextInline: React.FC<Props> = ({
  children,
  fontName = "",
  fontSize = "",
  className = "",
  center = false,
  textColor = "theme-label",
  maxLine = 0,
}) => {
  const classes: string = fontNameClass(
    fontName,
    fontSize,
    center,
    textColor,
    maxLine
  );
  return <div className={`d-inline ${classes} ${className}`}>{children}</div>;
};